import { apiRegister } from '../utils/api'

import { forEach, isArray } from '../utils/xp.v1'

// 247	oneminute	/oneminute/list/	获取一分钟列表
export const oneMinuteListLoad = apiRegister('oneMinuteListLoad', {
  protoId: 247,
  path: '/oneminute/list/',
  checkResult(result) {
    if (!isArray(result.list)) {
      return 300
    }
    return 0
  },
  formatResult(result) {
    forEach(result.list, function(TR) {
      let url = TR.url
      if (!url) {
        url = TR.mp3file
        if (url) {
          url = 'https://staticcdn.prd.pydp888.com/oneminute/' + url
        }
      }
      TR.url = url || ''
    })
    return result
  }
}).send

// 914	user/power	/user/power/daily/	计数并添加草根值 分享统计：_rf =invit
export const powerDailySubmit = apiRegister('powerDailySubmit', {
  protoId: 914,
  path: '/user/power/daily/'
}).send
